<template>
  <FloatingInput
    v-model="valueModel"
    name="zip"
    type="text"
    :label="label"
    :show-valid-icon="!valueModel.length ? false : validate"
    is-dark-floating-label
    :error="error"
    @onFocus="focusHandle"
    @onBlur="blurHandle"
  />
</template>

<script>
import FloatingInput from '@/components/FloatingInput';
import { validateUSAZipcode, validateNotUSAZipCode } from '@/utilities/validators';

export default {
  components: {
    FloatingInput,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    country: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: 'Postal / ZIP code',
    },
    error: {
      type: String,
      default: '',
    },
  },
  methods: {
    focusHandle() {
      this.$emit('onFocus');
    },
    blurHandle() {
      this.$emit('onBlur');
    },
  },
  computed: {
    valueModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    validate() {
      // When USA country is selected, server requires a zip code - show error client side as well.
      const isUSA = this.country?.id === this.$store.getters.countryUsa.id;
      const zip = this.value.trim();

      if (isUSA) {
        return validateUSAZipcode(this.value);
      }
      if (!isUSA && zip?.length >= 1) {
        return validateNotUSAZipCode(zip);
      }
      return true;
    },
  },
};
</script>
